export enum AbandonmentModalDataEnum {
    PRIMARY_TEXT = 'Texto principal',
    SECONDARY_TEXT = 'Texto secundário',
    MODAL_TYPE = 'Tipo do modal',
    IDLE_TIME = 'Inativação de navegação',
    PAGE_ABANDONMENT = 'Abandono de página',
    TIME = 'Tempo exibição modal',
    WHATSAPP = 'Número do WhatsApp'
}